import { type ReactNode, type FC } from 'react';
import { Link } from 'dibs-elements/exports/Link.tsx';
import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from './Dropdown-style.scss';

type Props = {
    title: ReactNode;
    link: ReactNode;
    href?: string;
    onClick: () => void;
};

export const DropdownHeader: FC<Props> = ({ title, link, href, onClick }) => {
    return (
        <div
            className={classnames(
                styles.header,
                dibsCss.flex,
                dibsCss.justifyBetween,
                dibsCss.pyXsmall,
                dibsCss.pxSmall
            )}
        >
            <div className={dibsCss.sassyFontSubHeaderTypeNormal}>{title}</div>
            {link ? (
                <Link className={styles.headerLink} onClick={onClick} href={href}>
                    {link}
                </Link>
            ) : null}
        </div>
    );
};
